export default [
   
    {
        "code": "KE",
        "label": "Kenya",
        "phone": "254"
    },
    
    {
        "code": "TZ",
        "label": "United Republic of Tanzania",
        "phone": "255"
    },
    {
        "code": "UG",
        "label": "Uganda",
        "phone": "256"
    }
];
